export default ({ style }) => (
	<svg
		id="Layer_3"
		data-name="Layer 3"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 27 27"
	>
		<path
			style={style}
			className="cls-1"
			d="M13.5,21.385a7.863,7.863,0,0,0,2.756-.494.25.25,0,0,0-.176-.469,7.378,7.378,0,0,1-5.625-.2l.9-1.816a5.353,5.353,0,0,0,7.51-4.908.25.25,0,0,0-.5,0,4.794,4.794,0,0,1-4.613,4.84V16.386a.25.25,0,0,0-.25-.25,2.442,2.442,0,1,1,1.575-.574.249.249,0,1,0,.322.381,2.944,2.944,0,1,0-2.147.682v1.714A4.855,4.855,0,0,1,8.9,11.905a.25.25,0,1,0-.472-.163,5.122,5.122,0,0,0-.082,3.17L6.4,15.525A7.391,7.391,0,0,1,11.479,6.4a.252.252,0,0,0,.171-.31.249.249,0,0,0-.308-.172,7.9,7.9,0,0,0-5.351,10,.252.252,0,0,0,.238.173.291.291,0,0,0,.076-.011L8.5,15.39a5.36,5.36,0,0,0,2.416,2.779L10.008,20A7.386,7.386,0,0,1,7.651,18.01a.25.25,0,0,0-.4.306A7.837,7.837,0,0,0,13.5,21.385Z"
		/>
		<path
			style={style}
			className="cls-1"
			d="M13.5,5.615a.25.25,0,0,0-.25.25v2.3A5.307,5.307,0,0,0,9.623,9.793a.249.249,0,0,0,.018.362l1.429,1.231a.25.25,0,1,0,.326-.379L10.172,9.953a4.866,4.866,0,0,1,7.673,1.357.25.25,0,1,0,.445-.226,5.331,5.331,0,0,0-4.54-2.93V6.119a7.385,7.385,0,0,1,4.7,12.858.25.25,0,1,0,.336.371A7.885,7.885,0,0,0,13.5,5.615Z"
		/>
	</svg>
)
